<template>
  <div class="ace-feed-step-2 ace-content">
    <Header :images="dietType.images" :title="`${dietType.title} Diets`" />
    <h2 class="ace-feed-step-2__title">
      Please formulate a diet to 100%
    </h2>
    <div class="ace-feed-step-2__diet-name">
      <input
        type="text"
        placeholder="Enter a diet name, for your records"
        @change="setDietTitle"
      />
    </div>
    <table class="ace-feed-step-2__diet">
      <thead>
        <tr>
          <th class="ace-feed-step-2__delete">
            &nbsp;
          </th>
          <th class="ace-feed-step-2__ingredient">
            Ingredient
          </th>
          <th class="ace-feed-step-2__percentage">
            Diet DM%
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(component, index) in diet" :key="index">
          <td class="ace-feed-step-2__delete">
            <Button
              variant="dark"
              icon="cross"
              @click="deleteIngredient(index)"
            />
          </td>
          <td class="ace-feed-step-2__ingredient">
            <div class="ace-form__input ace-form__input--select">
              <select v-model="component.title">
                <option :value="null" disabled>
                  - Please choose -
                </option>
                <option
                  v-for="(ingredient, index) in ingredients"
                  :key="index"
                  :value="ingredient.title"
                >
                  {{ ingredient.title }}
                </option>
              </select>
            </div>
          </td>
          <td class="ace-feed-step-2__percentage">
            <div class="ace-form__field">
              <div class="ace-form__input">
                <input
                  v-model="component.percentage"
                  type="number"
                  min="0"
                  max="100"
                />
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tfoot v-if="calculatedDiet.length">
        <tr>
          <td class="ace-feed-step-2__message" colspan="2">
            <span v-if="showMessage">{{ messageText }}</span>
          </td>
          <td class="ace-feed-step-2__total">
            {{ percent(totalPercentage) }}
          </td>
        </tr>
      </tfoot>
    </table>
    <Button
      variant="dark"
      icon="plus"
      :text="buttonText"
      @click="addIngredient"
    />
    <template v-if="estimatedResult">
      <Divider v-if="calculatedDiet.length" />
      <div class="ace-feed-step-2__estimated">
        <h2 class="ace-feed-step-2__title">
          Estimated Carbon Footprint
        </h2>
        <div class="ace-feed-step-2__estimated-result">
          <Result :value="estimatedResult" unit="kg CO2-eq/tonne DM" />
        </div>
      </div>
      <ButtonGroup v-if="calculatedDiet.length">
        <Button
          variant="dark"
          icon="arrow"
          text="Click for breakdown and benchmark comparison"
          @click="$emit('nextStep')"
        />
      </ButtonGroup>
    </template>
    <!-- <pre>
      {{this.calculatedDiet}}
    </pre> -->
  </div>
</template>

<script>
/* eslint-disable */
import { round, percent, formatNumber } from '../../helpers';

import carbonFootprint from './_carbonFootprint';
import mappedDiet from './_mappedDiet';

import Header from '../Layout/Header.vue';
import ButtonGroup from '../Layout/ButtonGroup.vue';
import Button from '../Layout/Button.vue';
import Divider from '../Layout/Divider.vue';
import Result from '../Layout/Result.vue';

export default {
  data() {
    return {
      diet: [{ title: null, percentage: 100 }],
    };
  },
  props: ['dietType', 'ingredients'],
  // props: {},
  methods: {
    round,
    percent,
    formatNumber,
    addIngredient() {
      this.diet.push({ title: null, percentage: this.nextPercentage });

      this.$emit('setDiet', this.diet);
    },
    deleteIngredient(index) {
      this.diet.splice(index, 1);
    },
    setDietTitle(event) {
      this.$emit('setDietTitle', event.target.value);
    },
    carbonFootprint,
    mappedDiet,
  },
  computed: {
    totalPercentage() {
      return this.diet.reduce(
        (total, component) => parseInt(component.percentage, 10) + total,
        0
      );
    },
    nextPercentage() {
      return this.totalPercentage >= 100 ? 0 : 100 - this.totalPercentage;
    },
    showMessage() {
      return this.diet.length && this.totalPercentage !== 100;
    },
    messageText() {
      if (this.totalPercentage === 100) {
        return;
      }
      return `Please ensure that the total percentage ${
        this.totalPercentage < 100 ? 'adds up to' : 'does not exceed'
      } 100%`;
    },
    buttonText() {
      return `Add ${this.diet.length ? 'another ' : ''}ingredient`;
    },
    estimatedResult() {
      return this.carbonFootprint(this.calculatedDiet);
    },
    calculatedDiet() {
      return this.mappedDiet(this.diet, this.ingredients);
    },
  },
  watch: {
    diet: {
      deep: true,
      handler(after, before) {
        this.$emit('setDiet', after);
      },
    },
  },
  components: {
    Header,
    ButtonGroup,
    Button,
    Divider,
    Result,
  },
};
</script>

<style scoped lang="scss">
@import '~@/assets/styles/mixins';

.ace-feed-step-2 {
  $this: &;

  max-width: 680px;

  &__title {
    @include title;

    margin-top: 55px;
  }
  &__diet-name {
    margin: 25px auto 45px;
    input {
      border: 1px solid #707070;
      border-radius: 5px;

      max-width: 500px;
      padding: 5px 10px;
      width: 100%;

      font-size: 20px;
      line-height: 30px;
    }
  }
  &__diet {
    margin: 25px auto 45px;
    width: 100%;

    table-layout: fixed;
    tr + tr {
      td {
        padding-top: 5px;
      }
    }
    thead {
      th {
        color: #00a84e;

        padding-bottom: 15px;
      }
    }
    tfoot {
      font-weight: 700;
      td {
        padding-top: 15px;
      }
    }
    td {
      padding: 0 5px;
      &#{$this}__delete {
        padding: 0;
      }
    }
  }
  &__delete {
    width: 30px;
  }
  &__ingredient,
  &__specification {
    width: 100%;
  }

  &__percentage {
    width: 100px;
  }
  &__total {
    font-size: 20px;
  }
  &__diet-type {
    display: flex;
    flex-direction: column;
    &-name {
      @include title;

      margin-top: 25px;
    }
  }
  &__estimated {
    margin-bottom: 60px;
    &-result {
      margin: 40px 0 0;

      display: flex;

      justify-content: center;
    }
  }
}
</style>
